import { InvoiceProps } from "@/interfaces/invoices_types";
import { HistoryCardBase, formatDate } from "../Cards/Utils/CardHelper";

export function HistoryInvoiceCard({ invoice }: { invoice: InvoiceProps; }) {
    return (
        <HistoryCardBase key={invoice.invoice_id}>
            <div className="flex justify-between">
                <div className="flex flex-row items-center">
                    <h3>Invoice</h3>
                </div>
                <h4>Project:<span className="font-bold"> {invoice.project_name}</span></h4>
            </div>
            <div className="flex justify-between">
                <p>Notes: <span className="italic"> {invoice.notes ?? 'No notes'}</span></p>
                <p>Created on:<span className="font-bold"> {formatDate(invoice.invoice_date ?? '')}</span></p>
                {invoice.payment_status === "Sent" ? <p className="text-green-700">Sent on: {formatDate(invoice.invoice_date ?? '')}</p> 
                    : <p className="text-red-700">Not Sent</p>}
            </div>
        </HistoryCardBase>
    )
}
